import { FC, Fragment, useRef } from 'react';
import { MeterOptionExitSlip } from '../../../models/MeterOption';
import { Tooltip } from 'primereact/tooltip';
import { TieredMenu } from 'primereact/tieredmenu';
import ExitSlipCopyStudentList from './ExitSlipCopyStudentList';

interface Props {
  element: MeterOptionExitSlip;
  totalStudents: number;
}

export const ExitSlipSnapshotMeterTemplate: FC<Props> = ({ element, totalStudents }) => {
  const menu = useRef<TieredMenu>(null);

  return (
    <Fragment>
      <ExitSlipCopyStudentList
        menuRef={menu}
        studentsToCopy={element.users.map(user => {
          return { fullName: user.fullName ?? '', publicUserId: user.publicUserId };
        })}
      />
      <Tooltip target={`.span-tooltip`} mouseTrack position="top" />
      <span
        onClick={e => menu?.current?.toggle(e)}
        data-pr-tooltip={`${element.value} Students`}
        className={`${
          element.className
        } span-tooltip tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-overflow-hidden tw-border-none tw-px-2 tw-py-1 tw-text-center tw-font-atkinson tw-text-xs tw-font-bold tw-leading-4 ${
          element.label === 'NOT_ANSWERED' ? 'tw-text-[#393939]' : 'tw-text-white'
        }`}
        style={{ height: `${(element.value * 100) / totalStudents}%` }}
      >
        {Math.round((element.value * 100) / totalStudents)}%
      </span>
    </Fragment>
  );
};
